module.exports = __webpack_public_path__ + "1b83a6fcd980707e8fd11997909c3c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/officehours/routes/JoinPage/components/JoinSessionPage/images/zoom-instructions-3.jpg
// module id = 1129
// module chunks = 0